"use strict";import{Dialog as e}from"./src/Dialog.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-dialog",e);
//# sourceMappingURL=sp-dialog.js.map
